export default __webpack_public_path__ + "static/media/box1.5956c572.jpg";